import { fetchUtils } from '$utils/fetchUtils'
import { addNotification } from '#lib/stores.js'
import { DefaultNotification, NotificationType } from '$types/notification'
import { type MailTemplateEntry } from './MailTemplateConfig.model'

export function getMailTemplates() {
	return fetchUtils.get('/api/mailTemplates')
}

export function addMailTemplate(entry: MailTemplateEntry, successFunc: () => void) {
	const { mailName, mailTemplateId, daysUntilDeletion } = entry || {}
	fetchUtils
		.post('/api/mailTemplates/new', { mailName, mailTemplateId, daysUntilDeletion })
		.then((_r) => {
			addNotification(
				DefaultNotification('Neue Zuordnung erfolgreich angelegt.', NotificationType.SUCCESS)
			)
			successFunc()
		})
		.catch((_error) =>
			addNotification(
				DefaultNotification('Neue Zuordnung konnte nicht angelegt werden.', NotificationType.ERROR)
			)
		)
}

export function deleteMailTemplate(entryId: string, successFunc: () => void) {
	fetchUtils
		.get(`/api/mailTemplates/${entryId}/delete`)
		.then((_r) => {
			addNotification(
				DefaultNotification('Zuordnung erfolgreich entfernt.', NotificationType.SUCCESS)
			)
			successFunc()
		})
		.catch((_error) =>
			addNotification(
				DefaultNotification('Zuordnung konnte nicht entfernt werden.', NotificationType.ERROR)
			)
		)
}

export function updateMailTemplate(
	entry: MailTemplateEntry,
	successFunc: (entry: MailTemplateEntry) => void
) {
	const { id, mailName, mailTemplateId, daysUntilDeletion } = entry || {}
	fetchUtils
		.post(`/api/mailTemplates/${id}/update`, { mailName, mailTemplateId, daysUntilDeletion })
		.then((_r) => {
			addNotification(
				DefaultNotification('Zuordnung erfolgreich aktualisiert.', NotificationType.SUCCESS)
			)
			successFunc(entry)
		})
		.catch((_error) =>
			addNotification(
				DefaultNotification('Zuordnung konnte nicht aktualisiert werden.', NotificationType.ERROR)
			)
		)
}

export function updateMailTemplateSender(successFunc: (message: string) => void) {
	fetchUtils
		.get(`/api/mailTemplates/updateSender`)
		.then((r) => {
			addNotification(
				DefaultNotification('Sender erfolgreich aktualisiert.', NotificationType.SUCCESS)
			)
			successFunc(r)
		})
		.catch((_error) =>
			addNotification(
				DefaultNotification('Sender konnte nicht aktualisiert werden.', NotificationType.ERROR)
			)
		)
}
